import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../authorization/authService";

export const activeCaseApi = createApi({
  reducerPath: "activeCaseApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ActiveCases", "AwardedApplications"],
  endpoints: (builder) => ({
    getActiveCases: builder.query({
      query: () => ({
        url: "/active_case/list",
        method: "GET",
      }),
      providesTags: ["ActiveCases"],
    }),
    getAwardedApplications: builder.query({
      query: () => ({
        url: "/active_case/awarded-applications",
        method: "GET",
      }),
      providesTags: ["AwardedApplications"],
    }),
  }),
});

export const { useGetActiveCasesQuery, useGetAwardedApplicationsQuery } =
  activeCaseApi;
